import { DocumentFile, DocumentFileType, DocumentRecord } from '../../models/Document'

export const ALL_UPLOADERS_FILTER_ID = 'all'

export const getDocumentFile = (document: DocumentRecord | null): DocumentFile | undefined => document?.files.at(0)

export const isSameDocumentFile = (a?: DocumentFile, b?: DocumentFile): boolean => {
  if (!a || !b) {
    return a === b
  }
  if (a.type === DocumentFileType.INTEGRATION && b.type === DocumentFileType.INTEGRATION) {
    return a.connector === b.connector && a.fileId === b.fileId
  }
  return a.type === b.type && a.fileId === b.fileId
}
